/**
 * QUÉ COMIDAS SE COMPARTEN SOLAS AL QUEDAR EL DÍA CUADRADO (Jesús, 27-09: «las comidas se
 * comparten por defecto si están todas cuadradas»). Puro: lo usa NutritionPage.
 *
 * - Solo con el día cuadrado y si no lo ha apagado en Mi perfil (`compartir === false`).
 * - Ni el intra ni el post.
 * - Al menos dos alimentos distintos (lo mismo que pide el servidor).
 * - Ni lo ya compartido (`compartidas`, por firma) ni lo ya mandado en esta visita
 *   (`yaMandadas`, por fecha, comida y firma).
 * La firma es la del servidor: los ids de los alimentos, sin repetir, ordenados y con guiones.
 */
export const firmaDeComida = (alimentos) =>
    [...new Set((alimentos || []).map((f) => Number(f.alimento_id)).filter(Number.isFinite))]
        .sort((x, y) => x - y)
        .join('-');

export const comidasParaCompartir = ({
    diaCuadrado, compartir, orden, comidas, compartidas, yaMandadas, fecha,
}) => {
    if (!diaCuadrado || compartir === false) return [];
    return (orden || [])
        .filter((k) => !['Intra', 'Post'].includes(k))
        .map((k) => {
            const alimentos = comidas?.[k]?.alimentos || [];
            const firma = firmaDeComida(alimentos);
            return { comida: k, alimentos, firma, clave: `${fecha}|${k}|${firma}` };
        })
        .filter((c) => c.firma.split('-').filter(Boolean).length >= 2)
        .filter((c) => !compartidas?.has?.(c.firma) && !yaMandadas?.has?.(c.clave));
};

export default comidasParaCompartir;
